import { render } from 'react-dom';
import App from './App';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/plugins/nucleo/css/nucleo.css';
import 'assets/scss/argon-dashboard-react.scss';

render(<App />, document.getElementById('root'));
